<template>
  <Dialog
    :visible="visible"
    header="Please check this value"
    :modal="true"
    :closable="true"
    :style="{ width: '480px' }"
    @update:visible="onVisible"
  >
    <ul id="anomalyWarnings" class="anomaly-warnings">
      <li v-for="(w, i) in warnings" :key="i">{{ w.message }}</li>
    </ul>
    <p class="anomaly-hint">Go back to correct it, or save it as it is if the value is right.</p>
    <template #footer>
      <Button id="anomalyGoBack" label="Go back" icon="pi pi-arrow-left" class="p-button-text" @click="answer(false)" />
      <Button id="anomalySaveAnyway" label="Save anyway" icon="pi pi-check" class="p-button-warning" @click="answer(true)" />
    </template>
  </Dialog>
</template>

<script>
// Batch 5. Mounted once in App.vue. quotationRequest() asks through anomalyConfirm() on the
// event bus; this dialog shows the warnings and answers "Save anyway" (true) or "Go back" (false).
// Closing it with the X or Escape is "Go back".
import EventBus from '@/event-bus'
import { ANOMALY_CONFIRM } from './anomalyConfirm'

export default {
  data: () => ({
    visible: false,
    warnings: [],
    pending: null
  }),
  created() {
    EventBus.$on(ANOMALY_CONFIRM, this.ask)
  },
  beforeDestroy() {
    EventBus.$off(ANOMALY_CONFIRM, this.ask)
    this.answer(false)
  },
  methods: {
    ask(request) {
      request.taken = true
      // a second question while one is open: the first is answered "Go back"
      if (this.pending) this.answer(false)
      this.pending = request
      this.warnings = request.warnings || []
      this.visible = true
    },
    answer(ok) {
      var request = this.pending
      this.pending = null
      this.visible = false
      if (request) request.answer(ok)
    },
    onVisible(value) {
      if (!value) this.answer(false)
    }
  }
}
</script>

<style scoped>
.anomaly-warnings { margin: 0 0 1rem; padding-left: 1.25rem; }
.anomaly-warnings li { margin-bottom: 0.5rem; font-weight: 600; }
.anomaly-hint { color: #6c757d; margin: 0; }
</style>
